import React from 'react';
import dg from '../images/dg.png';
import positive from '../images/positive.png';
import negative from '../images/negative.png';
import { Divider, Grid, Header, Image, Segment } from 'semantic-ui-react';

const DermaGlucan = () => {
  return (
    <Segment raised>
      <Header as='h1' textAlign='center'>
        DermaGlucan
        <Header.Subheader>
          Natural glucan active for skin care
        </Header.Subheader>
      </Header>

      <Divider />

      <Image size='large' centered src={dg} /><br/>

      <Grid stackable padded divided columns={2}>
        <Grid.Column className='large-text'>
          <Header as='h1' textAlign='center'>
            CarboxyMethyl(CM)-glucan
            <Header.Subheader>
              Other cosmetic products
            </Header.Subheader>
          </Header>

          <Image size='mini' centered src={negative} />
          <p>Can only be produced chemically and is not suitable for natural cosmetic products.</p>
          
          <Image size='mini' centered src={negative} />
          <p>Limited water solubility means most suppliers offer only 1% solutions.</p>
          
          <Image size='mini' centered src={negative} />
          <p>Charged chemical groups may lead to undesired precipitates with other cosmetic ingredients, especially surfacants.</p>
        </Grid.Column>

        <Grid.Column className='large-text'>
          <Header as='h1' textAlign='center'>
            DermaGlucan&trade;
            <Header.Subheader>
              Natural yeast glucan
            </Header.Subheader>
          </Header>

          <Image size='mini' centered src={positive} />
          <p>Natural beta-glucan unchanged as it occurs in the living yeast: neither degraded nor chemically modified.</p>
          
          <Image size='mini' centered src={positive} />
          <p>10% concentrations without causing problems during handling.</p>
          
          <Image size='mini' centered src={positive} />
          <p>Chemically neutral and does not cause any precipitates with other components of cosmetic formulations.</p>
        </Grid.Column>
      </Grid>
    </Segment>
  );
}

export default DermaGlucan;


// WEBPACK FOOTER //
// ./src/components/DermaGlucan.js